module.exports = {
	encode: s => s.replace(/[^a-zA-Z0-9-]/g, '-').toLowerCase(),
	randomElements: (a, n) => a.sort(() => .5 - Math.random()).slice(0, n),
	truncate: (s, l) => {
		if (s.length > l) return `${ s.substring(0, l) }...`;
		return s;
	},
	uniqueValues: a => a.filter((v, i, a) => a.findIndex(b => JSON.stringify(b) === JSON.stringify(v)) === i)
};
